module.exports = __webpack_public_path__ + "static/media/triporg--background.69ad52e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/porfolio/triporg/triporg--background.jpg
// module id = 168
// module chunks = 0